var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from '@ally/metronome-ui';
import React from 'react';
import { TextInput } from '../../inputs';
import { invalidStrings } from '../../validations';
export const defaultValidate = (variant, value, required, badWordsObject, NAME_PATTERN = /^[A-Za-z'\-\s]+$/) => {
    let variantMaxLength;
    let variantName;
    // For max lengths see PersonNameRepresentation:
    // https://bitbucket.int.ally.com/projects/DAO/repos/dao-applications/browse/dao-applications-v1.yaml#1641
    switch (variant) {
        case 'First Name':
            variantMaxLength = 17;
            variantName = 'first name';
            break;
        case 'Last Name':
            variantMaxLength = 30;
            variantName = 'last name';
            break;
        case `Mother's Maiden Name`:
            variantMaxLength = 20;
            variantName = `mother's maiden name`;
            break;
        default:
            variantMaxLength = 20;
            variantName = 'name';
    }
    // if the input is not required then an empty field should never show a validation error
    if (!required && !value) {
        return undefined;
    }
    if (!value) {
        return `Enter ${variantName} to continue.`;
    }
    if (value.length > variantMaxLength) {
        return `Your ${variantName} can't contain more than ${variantMaxLength} characters.`;
    }
    if (!NAME_PATTERN.test(value)) {
        return `Enter a valid ${variantName}.`;
    }
    if (badWordsObject) {
        const invalidStringsValidator = invalidStrings.validator(badWordsObject);
        if (!invalidStringsValidator(value)) {
            return invalidStrings.errorMessage;
        }
    }
    return undefined;
};
const Name = (_a) => {
    var { autoComplete = 'off', className, name, variant, required = false, validate, width, badWordsObject } = _a, props = __rest(_a, ["autoComplete", "className", "name", "variant", "required", "validate", "width", "badWordsObject"]);
    const fallback = (value) => defaultValidate(variant, value, required, badWordsObject);
    const variantLabels = {
        'First Name': 'First name',
        'Last Name': 'Last name',
        "Mother's Maiden Name": "Mother's maiden name",
    };
    return (React.createElement(Box, { className: className, width: width },
        React.createElement(TextInput, Object.assign({ labelContent: variantLabels[variant], required: required, autoComplete: autoComplete, isPrivate: true, inputType: "text", name: name, validate: validate || fallback }, props))));
};
export default Name;
//# sourceMappingURL=Name.js.map